



















import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { IsProgressFormOpenMixin } from '@/pages/profile/mixins';
import store from '@/pages/profile/store';
import Child from './child';
import { IChildrenList } from './types';

@Component({
  components: {
    Child,
  },
})
export default class ChildrenList
  extends Mixins(IsProgressFormOpenMixin)
  implements IChildrenList {
  @Prop({ type: Object, default: () => {} })
  readonly item!: any;

  @Prop({ type: Array, default: () => [] })
  readonly modules!: Array<string>;

  public index: number = 0;

  get selector(): number {
    return store.state.selector;
  }

  get modal(): boolean {
    return store.state.modal;
  }

  get isProgress(): boolean {
    return !!this.$route.matched.some(({ meta }) => meta.progress);
  }

  get isPfdod(): boolean {
    return !!this.$route.matched.some(({ meta }) => meta.pfdod);
  }

  beforeMount(): void {
    this.index = this.selector;
  }

  showModal() {
    store.modal = true;
  }

  childEvent(event: string): void {
    this.$emit(event);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/children/sidebar/components/childrenlist/ChildrenList.vue